var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H3C1.3455 0 0 1.3455 0 3V21C0 22.6545 1.3455 24 3 24H21C22.6545 24 24 22.6545 24 21V3C24 1.3455 22.6545 0 21 0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75098 9.58618H7.92896V19.4384H4.75098V9.58618Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3737 9.37402C14.0448 9.37402 13.0218 10.6684 12.7643 11.0624V9.58606H9.83594V19.4382H13.0141V14.4894C13.0141 13.0594 13.6724 11.947 14.921 11.947C16.1694 11.947 16.3737 13.3317 16.3737 15.0344V19.4382H19.5519V12.5522C19.5519 10.7969 18.129 9.37402 16.3737 9.37402Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23175 6.45361C8.23175 7.49841 7.38489 8.34528 6.34009 8.34528C5.29529 8.34528 4.44824 7.49841 4.44824 6.45361C4.44824 5.40881 5.29529 4.56177 6.34009 4.56177C7.38489 4.56177 8.23175 5.40881 8.23175 6.45361Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.96847,
    y1: 3.37435,
    x2: 14.0388,
    y2: 16.3619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066B2"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b654af9326fb8480b7fd4b47da177a88.svg";
export { ForwardRef as ReactComponent };